export const Footer = () => (
  <footer className="border-t border-ink/10 py-16" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-10 px-6 md:flex-row md:items-center md:px-12">
      <div className="flex items-center gap-4">
        <img src="/assets/logo.png" alt="Unlabeled Wine Club" className="aspect-square h-14 w-14 rounded-full object-cover mix-blend-multiply" />
        <div>
          <p className="font-serif text-lg tracking-tight">Unlabeled Wine Club</p>
          <p className="text-xs uppercase tracking-[0.25em] text-ink/50">
            Wines of all kinds, shipped out to members
          </p>
        </div>
      </div>
      <div className="text-sm text-ink/60">
        <p data-testid="footer-service-area">Shipping nationwide across the US</p>
        <p className="mt-1" data-testid="footer-contact">hello@unlabeledwineclub.com</p>
      </div>
      <p className="text-xs text-ink/40">© {new Date().getFullYear()} Unlabeled Wine Club. Drink responsibly. 21+ only.</p>
    </div>
  </footer>
);
